import { useEffect, useMemo, useState } from "react";
import SEO from "../lib/seo";
import PageHero from "../components/PageHero";
import FaqAccordion from "../components/FaqAccordion";
import CtaSection from "../components/CtaSection";
import { Reveal } from "../components/Reveal";
import { getFaqs } from "../lib/api";

const HERO_IMG =
  "https://images.unsplash.com/photo-1569530593523-083e18aecc75?crop=entropy&cs=srgb&fm=jpg&q=80&auto=format&fit=crop&w=1800";

export default function Faq() {
  const [faqs, setFaqs] = useState([]);
  const [cat, setCat] = useState("Semua");

  useEffect(() => {
    getFaqs().then(setFaqs).catch(() => {});
  }, []);

  const cats = useMemo(
    () => ["Semua", ...Array.from(new Set(faqs.map((f) => f.category)))],
    [faqs]
  );
  const filtered = cat === "Semua" ? faqs : faqs.filter((f) => f.category === cat);

  return (
    <>
      <SEO
        title="FAQ — Pertanyaan Seputar Land Arrangement | Beyond Travel"
        description="Jawaban seputar Land Arrangement, custom itinerary, private transportation, halal food, group, corporate, quotation, booking, dan pembayaran."
      />
      <PageHero
        image={HERO_IMG}
        eyebrow="FAQ"
        title="Pertanyaan yang Sering Diajukan"
        sub="Semua yang perlu Anda ketahui tentang Land Arrangement dan cara kami bekerja."
        crumb="FAQ"
      />

      <section className="section bg-cream">
        <div className="container-x max-w-4xl">
          <div className="flex flex-wrap justify-center gap-2" data-testid="faq-filter">
            {cats.map((c) => (
              <button
                key={c}
                onClick={() => setCat(c)}
                data-testid={`faq-category-${c.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                className={`chip px-4 py-2 transition-all duration-300 ${
                  cat === c
                    ? "bg-tosca-600 text-white shadow-[0_8px_20px_-8px_rgba(15,118,110,0.6)]"
                    : "bg-white text-slate-500 hover:text-tosca-700 shadow-crystal"
                }`}
              >
                {c}
              </button>
            ))}
          </div>
          <div className="mt-8">
            <Reveal>
              <FaqAccordion items={filtered} />
            </Reveal>
          </div>
        </div>
      </section>

      <CtaSection title="Masih Ada Pertanyaan?" sub="Tim kami siap menjawab semua pertanyaan perjalanan Anda lewat WhatsApp." testid="cta-faq" />
    </>
  );
}
